import { createAsyncThunk } from '@reduxjs/toolkit';
import { projectSvc as service } from "services/serviceStorage";
import { BaseApiResponse, Project } from 'common/types';
import { ProjectGridFilter } from './types';
import { wrapRequest } from "common/utils";

export const fetchProjects = createAsyncThunk<{ items: Project[], totalCount: number }, { filter: ProjectGridFilter }>(
    'projectMgmt/fetchProjects',
    async (params) => {
        const { data } = await wrapRequest<BaseApiResponse<{ items: Project[]; totalCount: number }>>({
            handler: () => service.getProjects(params.filter),
            showNotifications: true
        });

        return data!.result;
    }
);

export const saveProject = createAsyncThunk<void, Project>(
    'projectMgmt/saveProject',
    async (project, { rejectWithValue }) => {
        const err = await wrapRequest<BaseApiResponse<void>>({
            handler: () => service.putProject(project),
            showNotifications: true
        });

        if (err.errors?.length || err.warnings?.length) {
            return rejectWithValue(err);
        }
    }
);

export const getProject = createAsyncThunk<Project, number>(
    'projectMgmt/getProject',
    async (projectId) => {
        const { data } = await wrapRequest<BaseApiResponse<Project>>({
            handler: () => service.getProject(projectId),
            showNotifications: true
        });

        return data!.result;
    }
);

export const deleteProject = createAsyncThunk<void, number>(
    'projectMgmt/deleteProject',
    async (projectId, { rejectWithValue }) => {
        const err = await wrapRequest<BaseApiResponse<void>>({
            handler: () => service.deleteProject(projectId),
            showNotifications: true
        });

        if (err.errors?.length || err.warnings?.length) {
            return rejectWithValue(err);
        }
    }
);

export const archiveProject = createAsyncThunk<void, number>(
    'projectMgmt/archiveProject',
    async (projectId, { rejectWithValue }) => {
        const err = await wrapRequest<BaseApiResponse<void>>({
            handler: () => service.archiveProject(projectId),
            showNotifications: true
        });

        if (err.errors?.length || err.warnings?.length) {
            return rejectWithValue(err);
        }
    }
);

export const forceDeleteProject = createAsyncThunk<void, number>(
    'projectMgmt/forceDeleteProject',
    async (projectId, { rejectWithValue }) => {
        const err = await wrapRequest<BaseApiResponse<void>>({
            handler: () => service.forceDeleteProject(projectId),
            showNotifications: true
        });

        if (err.errors?.length || err.warnings?.length) {
            return rejectWithValue(err);
        }
    }
);